"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiPinterest = function IconUiPinterest(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M14.257 42.674q.048.635.146 1.66.1.781.2 1.661a.335.335 0 0 0 .245.293.34.34 0 0 0 .342-.1q.732-.928 1.367-1.856a20.673 20.673 0 0 0 3.023-6.152l1.758-6.739a4.873 4.873 0 0 0 2.3 2.1 7.564 7.564 0 0 0 3.663.928 11.449 11.449 0 0 0 9.523-4.787q3.663-4.687 3.663-12.014a13.134 13.134 0 0 0-4.2-9.719A15.771 15.771 0 0 0 25 3.7q-8.108 0-13.089 5.03a14.06 14.06 0 0 0-4.4 10.257A12.437 12.437 0 0 0 8.738 24.7a7.123 7.123 0 0 0 3.76 3.614 1.062 1.062 0 0 0 .782 0 .767.767 0 0 0 .439-.586l.538-2a1.024 1.024 0 0 0 .048-.683 1.752 1.752 0 0 0-.439-.684 7.3 7.3 0 0 1-1.566-4.788 11.431 11.431 0 0 1 3.223-8.2 11.884 11.884 0 0 1 8.84-3.517 10.276 10.276 0 0 1 7.522 2.686 8.867 8.867 0 0 1 2.637 6.691 18.236 18.236 0 0 1-2.149 9.182q-2.247 3.858-5.617 3.858a3.851 3.851 0 0 1-3.125-1.416 3.651 3.651 0 0 1-.733-3.321q.1-.487 1.368-4.64a16.53 16.53 0 0 0 .781-4.053 4.15 4.15 0 0 0-.781-2.589 3.037 3.037 0 0 0-2.491-1.074 3.968 3.968 0 0 0-3.321 1.807 7.141 7.141 0 0 0-1.417 4.542 8.573 8.573 0 0 0 .782 3.858l-3.172 13.328a23.842 23.842 0 0 0-.39 5.959z"
  }));
};

IconUiPinterest.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiPinterest;
exports.default = _default;